import { render } from "./MobilesongToggel.vue?vue&type=template&id=2dc37e54"
import script from "./MobilesongToggel.vue?vue&type=script&lang=js"
export * from "./MobilesongToggel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__